// ═══════════════════════════════════════════════════════════════════════════
// Marketplace category → icon + color lookup.
//
// This is the ONLY frontend file that still declares per-category presentation
// (emoji icon + accent color). Everything else (id, displayName, description,
// connector counts, membership) now comes from the backend
// ConnectorRegistryService — the single source of truth.
//
// Keep the ids here in sync with
//   backend/src/main/resources/connectors/registry/_categories.json
// ═══════════════════════════════════════════════════════════════════════════

const CATEGORY_STYLES = {
  // AI
  'llm-provider':      { icon: '🧠', color: '#8b5cf6' },
  'vector-store':      { icon: '🔗', color: '#6d28d9' },
  'ai-ml-platform':    { icon: '🤖', color: '#7c3aed' },

  // Security
  'siem-log':          { icon: '📊', color: '#dc2626' },
  'edr-xdr':           { icon: '🛡️', color: '#ea580c' },
  'threat-intel':      { icon: '🔍', color: '#7c3aed' },
  'vuln-mgmt':         { icon: '🐛', color: '#b91c1c' },
  'iam':               { icon: '🔐', color: '#2563eb' },
  'iag':               { icon: '📋', color: '#0d9488' },
  'network-sec':       { icon: '🌐', color: '#0891b2' },
  'email-sec':         { icon: '📧', color: '#c026d3' },
  'cloud-sec':         { icon: '☁️', color: '#0284c7' },
  'casb-sase':         { icon: '🔒', color: '#6366f1' },
  'secrets-vault':     { icon: '🔑', color: '#92400e' },

  // ITSM / productivity / business
  'ticketing':         { icon: '🎫', color: '#16a34a' },
  'communication':     { icon: '💬', color: '#d946ef' },
  'crm':               { icon: '📈', color: '#0284c7' },

  // Data
  'cloud-storage':     { icon: '🗄️', color: '#0369a1' },
  'data-warehouse':    { icon: '🏢', color: '#1e40af' },
  'event-integration': { icon: '📡', color: '#0e7490' },
  'database':          { icon: '💾', color: '#15803d' },

  // Utility / fallback
  'fun':               { icon: '🎮', color: '#52525b' },
  'uncategorized':     { icon: '📦', color: '#71717a' },
};

const DEFAULT_STYLE = { icon: '🔌', color: '#71717a' };

/**
 * Returns the icon + color for a category id (kebab-case), or a neutral
 * default if the id is unknown.
 */
export function getCategoryStyle(id) {
  if (!id) return DEFAULT_STYLE;
  return CATEGORY_STYLES[id] || DEFAULT_STYLE;
}

export { CATEGORY_STYLES, DEFAULT_STYLE };
